"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockWindowDisplayWorker = void 0;
class MockWindowDisplayWorker {
    constructor(mockPath = 'MockPath') {
        this.mockPath = mockPath;
        this.errorMessage = '';
        this.warningMessage = '';
        this.infoMessage = '';
        this.clipboardText = '';
        this.options = [];
        this.callback = undefined;
    }
    showErrorMessage(message, callback, ...items) {
        this.errorMessage = message;
        this.options = items;
        this.callback = callback;
    }
    showWarningMessage(message, callback, ...items) {
        this.warningMessage = message;
        this.options = items;
        this.callback = callback;
    }
    showInformationMessage(message, callback, ...items) {
        this.infoMessage = message;
        this.callback = callback;
    }
    copyToUserClipboard(text) {
        return __awaiter(this, void 0, void 0, function* () {
            this.clipboardText = text;
        });
    }
    getModalWarningResponse(message, no, yes) {
        return __awaiter(this, void 0, void 0, function* () {
            return true;
        });
    }
    displayPathConfigPopUp() {
        return new Promise((resolve) => { resolve(this.mockPath); });
    }
}
exports.MockWindowDisplayWorker = MockWindowDisplayWorker;
//# sourceMappingURL=MockWindowDisplayWorker.js.map